// SPDX-License-Identifier: AGPL-3.0-or-later

export const INCOMING_CALL_OVERLAY_HEIGHT = 400;
export const INCOMING_CALL_OVERLAY_STORAGE_KEY = 'incoming_call_overlay_position';
export const INCOMING_CALL_OVERLAY_WIDTH = 320;
